import script from "./ScheduleView.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleView.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleView.vue?vue&type=style&index=0&id=2d91313c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d91313c"]])

export default __exports__